import React from 'react';
import { AiOutlinePhone, AiOutlineVideoCamera } from 'react-icons/ai';
import { Row, Col } from 'react-bootstrap';
import styles from './style.scss';

function ConferenceData({ event }) {
  const entryPoints = event.getIn(['conferenceData', 'entryPoints']);

  const videoData = entryPoints.find((entry) => entry.get('entryPointType') === 'video');
  const phoneData = entryPoints.find((entry) => entry.get('entryPointType') === 'phone');
  return (
    <div>
      <hr />
      {videoData && (
        <Row top="xs" start="xs" style={{ marginTop: 10 }}>
          <AiOutlineVideoCamera size={25} style={{ marginRight: 5, width: 25 }} />
          <a href={videoData.get('uri')} className={styles.zoomButton}>
            Zoom
          </a>
        </Row>
      )}
      {phoneData && (
        <Row top="xs" start="xs" style={{ marginTop: 10 }}>
          <Col xs={12}>
            <AiOutlinePhone size={25} style={{ marginRight: 5, width: 25 }} />
            {phoneData.get('label')}
          </Col>
        </Row>
      )}
    </div>
  );
}

export default ConferenceData;
